<template>
	<div>
		<div class="input-group" v-if="inputType=='text'">
			<input v-model="value.min" type="text" class="form-control outline-secondary" :placeholder="placeholder.split('|')[0]" >
			<input v-model="value.max" type="text" class="form-control outline-secondary" :placeholder="placeholder.split('|')[1]" >
		</div>
		<div class="input-group" v-if="inputType=='number'">
			<input v-model="value.min" type="number" class="form-control outline-secondary" :placeholder="placeholder.split('|')[0]" >
			<input v-model="value.max" type="number" class="form-control outline-secondary" :placeholder="placeholder.split('|')[1]" >
		</div>
		<div class="input-group" v-if="inputType=='money'">
			<ReInputMask v-model="value.min" mask="money" :placeholder="placeholder.split('|')[0]" />
			<ReInputMask v-model="value.max" mask="money" :placeholder="placeholder.split('|')[1]" />
		</div>
	</div>
</template>

<script>
	import ReInputMask from "src/our_components/ReInputMask.vue";

	export default {
		name: 'ReInputRange',
		components: {
			ReInputMask,
		},
		props: {
			// value: Object,
			value: {
				type: Object,
				default() {	return {}; }
			},
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			placeholder: {
				type: String,
				default: 'от|до',
			},
			inputType: {
				type: String,
				default: 'text', // 'text'|| 'number'
			},
		},
		data () {
			return {
				ver: 1,
				
			}
		},
		watch: {
			value:{
				
				handler(value){
					this.$emit('input', value);
					// console.log('ReInputRange', value);
				},
				deep: true,
			},
			
		},
		computed: {
			

		},
		methods: {
			sendinput(val){
				// console.log('ReInputRange', val);
				// this.$emit("input", val);
				
			}
		},
	}
</script>
<style scoped>
/* .input-group .ReInputMask .form-control:first-child {
    border-right: 0 none;
}

.input-group .ReInputMask .form-control:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
} */

.input-group >>> .ReInputMask:nth-child(1) input {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
    border-left: 1px solid;
	border-color: #6679b0;

}
.input-group >>> .ReInputMask:nth-child(2) input {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
	border-right: 1px solid;
	border-color: #6679b0;
}

.white-content .input-group >>> .ReInputMask:nth-child(1) input, .white-content .input-group >>> .ReInputMask:nth-child(2) input {
	border-color: rgba(0, 0, 0, 0.7);
}
.input-group >>> .ReInputMask:nth-child(1) input:focus, .input-group >>> .ReInputMask:nth-child(2) input:focus {
	border-color: #01B0E0;
}

/* .input-group >>> .ReInputMask:nth-child(1) input */

</style>
